export default __webpack_public_path__ + "static/media/right-arrow.31d0b4e1.svg";